<template>
  <button type="button" class="btn btn-outline-primary" @click="go" title="Add Order">
    <span class="fw-bold mx-1">&plus;</span>
    Add Order
  </button>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

function go() {
  router.push({ name: 'NewOrder', params: { storeKey: route.params.storeKey } })
}
</script>
